import { render, staticRenderFns } from "./ProtobufDecoderConfiguration.vue?vue&type=template&id=7861155c&"
import script from "./ProtobufDecoderConfiguration.vue?vue&type=script&lang=ts&"
export * from "./ProtobufDecoderConfiguration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports